import React from "react";

import { Box, Card, CardActionArea, CardActions, CardContent, Grid, Typography } from "@material-ui/core";
import { useTheme, withStyles } from "@material-ui/core/styles";

import { Store } from "modules/customer/tools/product/store";
import numberFormatter from "utils/numberFormatter";
import BarChart from "pages/customer/tools/product/filters/BarChart";
import SimpleTooltip, { SimpleTooltipPlacement } from "components/SimpleTooltip";
import stringUtils from "utils/stringUtils";

const StyledCard = withStyles(theme => ({
    root: {
        // @ts-ignore
        backgroundColor: theme.palette.quaternary.main,
        borderColor: (props: any) => props["data-selected"] ? theme.palette.common.white : "transparent",
        borderStyle: "solid",
        borderWidth: "1px",
        height: "100%"
    }
}))(Card);

const StyledCardActions = withStyles(theme => ({
    root: {
        // @ts-ignore
        backgroundColor: theme.palette.quaternary.light
    }
}))(CardActions);

const StyledCardActionArea = withStyles(theme => ({
    root: {
        height: "100%",
        minWidth: "100%"
    }
}))(CardActionArea);

const StyledCardContent = withStyles(theme => ({
    root: {
        // @ts-ignore
        backgroundColor: theme.palette.quaternary.main
    }
}))(CardContent);

interface StoreCardProps {
    store: Store,
    selected: boolean,
    onSelect: (store: Store) => void,
    onDeselect: (store: Store) => void
}

const MAX_STORE_NAME_LENGTH = 30;

const StoreCard: React.FC<StoreCardProps> = (props) => {
    const { store, selected, onSelect, onDeselect } = props;
    const theme = useTheme();
    const showLabel = false;
    const truncatedStoreName = stringUtils.truncate(store.name, MAX_STORE_NAME_LENGTH);
    const disableTooltip = store.name.length <= MAX_STORE_NAME_LENGTH;

    const handleClick = () => {
        if (selected) {
            onDeselect(store);
        } else {
            onSelect(store);
        }
    };

    return (
        <StyledCard elevation={0} data-selected={selected}>
            <StyledCardActionArea onClick={handleClick} disableRipple disableTouchRipple>
                <StyledCardActions style={{ height: theme.spacing(12) }}>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <SimpleTooltip title={store.name} placement={SimpleTooltipPlacement.Top} disableHoverListener={disableTooltip} >
                                <Typography
                                    variant="h6"
                                    component="div"
                                    align="center"
                                >
                                    {truncatedStoreName}
                                </Typography>
                            </SimpleTooltip>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography
                                variant="body1"
                                component="div"
                                align="center"
                                noWrap
                                style={{ color: theme.palette.text.secondary }}
                            >
                                Headroom
                            </Typography>
                            <Typography
                                variant="h5"
                                component="div"
                                align="center"
                            >
                                {numberFormatter.toGBP(store.sales.salesHeadroom, 1)}
                            </Typography>
                        </Grid>
                    </Grid>
                </StyledCardActions>
                <StyledCardContent>
                    <BarChart sales={store.sales} />
                </StyledCardContent>
                {showLabel && <StyledCardActions>
                    <Box display="flex" justifyContent="center" alignItems="center" width="100%">
                        <Typography
                            variant="h6"
                            component="span"
                            align="center"
                            display="inline"
                            style={{ color: theme.palette.text.primary }}
                        >
                            Existing store
                        </Typography>
                    </Box>
                </StyledCardActions>}
            </StyledCardActionArea>
        </StyledCard>
    );
};

export default StoreCard;
